<template>
  <modal class="orderdetail-modal" title="订单详情" color="warn" buttonsHidden>
    <vx-form class="w-full" layout="v" label-align="none" v-slot="{invalid, handleSubmit}">
      <form-item label="订单号">{{order.orderid}}</form-item>
      <form-item label="标题">
        <router-link :to="'/product/edit/' + order.productID" title="点击查看并编辑商品">{{order.title}}</router-link>
      </form-item>
      <form-item label="用户">{{order.nickName}} [{{order.userName}}]</form-item>
      <form-item label="数量">{{order.number}}</form-item>

      <form-item label="印刷服务">{{order.printing ? '需要' : '不需要'}}</form-item>
      <div v-if="order.printing">
        <form-item label="标签尺寸">
          {{getSticky(order.stickyID).shape}} {{getSticky(order.stickyID).width}}CM *
          {{getSticky(order.stickyID).height}}CM
        </form-item>
        <form-item label="收货信息">
          <div>
            <div class="whitespace-no-wrap">联系人: {{order.contactName}}</div>
            <div class="whitespace-no-wrap">联系电话: {{order.contactPhone}}</div>
            <div>收货地址: {{order.address}}</div>
          </div>
        </form-item>
      </div>
      <form-item label="订单状态">{{orderStatus[order.status]}}</form-item>
      <form-item label="价格"><span class="text-danger">￥{{(order.amount / 100).toFixed(2)}}元</span></form-item>
      <form-item label="接单备注" v-if="order.dealContent">{{order.dealContent}}</form-item>

      <form-item label="管理员支付备注" v-if="adminPay">
        <div>
          <div class="whitespace-no-wrap">姓名: {{adminPay.name}}</div>
          <div class="whitespace-no-wrap">合同号: {{adminPay.contract}}</div>
          <div>备注: {{adminPay.reason}}</div>
        </div>
      </form-item>
      <form-item label="下单备注">
        {{order.comment}}
      </form-item>

      <vs-button class="mr-2" color="danger" @click="$modalClose()">关闭</vs-button>
    </vx-form>
  </modal>
</template>

<script>
  export default {
    name: "order-detail",
    props: {
      order: {
        type: Object,
        required: true,
      }
    },
    $computed: ['dict.orderStatus'],
    computed: {
      adminPay() {
        try {
          const data = JSON.parse(this.order.adminPay)
          return data
        } catch (e) {
          return ''
        }
      }
    },
    methods: {
      getSticky(id) {
        return this.$s.getSticky(id)
      },
    }
  }
</script>

<style lang="scss">
  .orderdetail-modal {
    .vs-dialog {
      max-width: 100%;
      width: 600px;
    }
  }
</style>